import { apiSlice } from "@app/api/apiSlice"

export const pickupLocationApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    loadAllPickupLocation: builder.mutation({
      query: (query) => `pickupLocs?${query}`,
    }),
    loadOnePickupLocation: builder.mutation({
      query: (query) => `pickupLocs/${query}`,
    }),
    addEditPickupLocation: builder.mutation({
      query: (data) => ({
        url: `pickupLocs`,
        method: "POST",
        body: data,
      }),
    }),
    deleteOnePickupLocation: builder.mutation({
      query: (id) => ({
        url: `pickupLocs/${id}`,
        method: "DELETE",
      }),
    }),
    deleteMultipleLocationRequest: builder.mutation({
      query: (data) => ({
        url: `pickupLocs/deleteAll`,
        method: "POST",
        body: { data },
      }),
    }),
    activeAllLocationRequest: builder.mutation({
      query: (data) => ({
        url: `pickupLocs/multiple/pickup`,
        method: "POST",
        body: { Location_id: data, type: "is_active" },
      }),
    }),
  }),
  overrideExisting: true,
})

export const {
  useLoadAllPickupLocationMutation,
  useLoadOnePickupLocationMutation,
  useAddEditPickupLocationMutation,
  useDeleteOnePickupLocationMutation,
  useDeleteMultipleLocationRequestMutation,
  useActiveAllLocationRequestMutation,
} = pickupLocationApiSlice
